export default "__VITE_ASSET__$hGLxXvM__"